"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const common_1 = require("../connectors/common");
const logger_1 = require("./logger");
function networkWatcher(connector, networks, manualNetworkMode) {
    connector.on(common_1.ConnectorEvents.WALLET_CHAIN_CHANGED, (chainId) => {
        const network = networks === null || networks === void 0 ? void 0 : networks.find((net) => net.chainId === chainId);
        (0, logger_1.getApplicationLogger)().debug('[network-watcher] received', chainId, 'found', network ? network : 'nothing');
        if (!manualNetworkMode &&
            network &&
            connector.continueNetworkUpdateFromWallet) {
            void connector.continueNetworkUpdateFromWallet(network);
        }
    });
}
exports.default = networkWatcher;
//# sourceMappingURL=network-watcher.js.map